// import './App.css';
import Home from './components/pages/Home';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css';
import './assets/css/index.css';
import "./index.css"
import About from './components/pages/About';
import Contact from './components/pages/Contact';
import Blogs from './components/pages/Blogs';
import Services from './components/pages/Services';
import WhatsappIcon from './components/WhatsappIcon/WhatsappIcon';
import SuccessPage from './components/pages/SuccessPage';
import ScrollToTop from './components/pages/ScrollToTop';
import Facilities from './components/pages/Facilities';

function App() {
  return (
    <>
      <WhatsappIcon />
      <BrowserRouter>
        <ScrollToTop>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/services" element={<Services />} />
            <Route path="/blogs" element={<Blogs />} />
            <Route path="/facilities" element={<Facilities />} />
            <Route path="/success" element={<SuccessPage />} />
          </Routes>
        </ScrollToTop>
      </BrowserRouter>
    </>
  );
}

export default App;
